import { render, staticRenderFns } from "./OrganizacaoRolesPermissoesModal.vue?vue&type=template&id=12e366da&scoped=true&"
import script from "./OrganizacaoRolesPermissoesModal.vue?vue&type=script&lang=js&"
export * from "./OrganizacaoRolesPermissoesModal.vue?vue&type=script&lang=js&"
import style0 from "./OrganizacaoRolesPermissoesModal.vue?vue&type=style&index=0&id=12e366da&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e366da",
  null
  
)

export default component.exports